<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0"><i class="fa fa-fw fa-archive mr-2" />Detail Kirim Invent</h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Kirim Inventaris <strong>{{ data.no_faktur }}</strong><br />
                    No. Request <strong>{{ data.sendback_request_number || "-" }}</strong><br />
                    Kirim Inventaris Dari <strong>Gudang {{ data.warehouse }} </strong><br />
                    Ditransaksikan oleh <strong>{{ data.confirmed_by }}</strong> pada {{ $helper.parseDate(data.confirmed_at) }}, {{ $helper.parseHourMinute(data.confirmed_at) }}<br />
                    Tanggal Perpindahan: <strong>{{ $helper.parseDate(data.send_date) }}</strong><br />
                    Divisi Barang: <strong>{{ data.division }}</strong><br />
                    Kategori: <strong>{{ data.inventory_category || "-" }}</strong> <br />
                    Dikirim Ke: <strong>{{ data.sent_to || "-" }}</strong><br />
                    Catatan Kirim Inventaris: {{ data.notes || "-" }}
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button variant="dark" @click="showInvoiceModal" :disabled="isShowing">
                        <i class="fa fa-print mr-2" />Cetak Faktur
                    </b-button>
                </b-col>
            </b-row>
            <hr />
            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="Pencarian No. Faktur / IMEI SN">
                        <b-form-input v-model="filterInput" maxlength="50" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :items="items"
                :fields="fields"
                :filter="filterInput"
                :filter-included-fields="['no_faktur_pgi', 'imei_sn']"
                responsive
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Tidak ada barang.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.index + 1 }}.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur_pgi }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                    </div>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-reprint-faktur" title="Cetak Ulang Faktur" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            <iframe :src="getInvoiceLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                            Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="hideInvoiceModal()">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isShowing: false,

            filterInput: "",
            invoiceLink: "",
            invoiceLinkA4: "",

            data: {},
            items: [],

            fields: [
                { key: "no", label: "No." },
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
            ],

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            let getData = this.$axios.get("inventory-pgi/details/" + this.$route.params.id, param).then(res => {

                this.data = res.data.data

            })
            .catch(error => this.$helper.parseError(this, error))

            let getItems = this.getItems()

            Promise.all([getData, getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => this.initStatus = -1)

        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return this.invoiceLink
            }
            else{
                return this.invoiceLinkA4
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },


        showInvoiceModal() {
            this.isShowing = true
            this.$bvModal.show('m-reprint-faktur')
        },

        hideInvoiceModal() {
            this.isShowing = false
            this.$bvModal.hide('m-reprint-faktur')
        },

        getItems(page){
            this.isBusy = true

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory-pgi/details/" + this.$route.params.id + param).then(res => {
                this.items = res.data.data.details.items.map(item => {
                    return {
                        id: item.detail_id,
                        type: item.type,
                        brand: item.brand,
                        kind: item.kind,
                        year: item.year,
                        no_faktur_pgi: item.no_faktur_pgi,
                        imei_sn: item.imei_sn,
                        inventory_id: item.item_id
                    }
                })
                this.totalRows = res.data.data.details.total
                this.data = res.data.data
                const cleanedString = res.data.data.link.replace(/\\/g, "");
                const cleanedStringa4 = res.data.data.linka4.replace(/\\/g, "");
                this.invoiceLink = `${this.$BASE_PRINT_FILE_PATH}${cleanedString}`;
                this.invoiceLinkA4 = `${this.$BASE_PRINT_FILE_PATH}${cleanedStringa4}`
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => { this.isBusy = false })
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        }

    },
    created() {
        this.init()
    }
}
</script>

<style>

</style>
